import {
  Component,
  Inject,
  OnInit
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import Swal from 'sweetalert2';

import { ClientProcessService }
from '../../../services/clientProcess/client-process.service';

@Component({
  selector: 'app-add-process',
  templateUrl: './add-process.component.html',
  styleUrls: ['./add-process.component.scss']
})
export class AddProcessComponent
implements OnInit {

  public process: any = {

    nombreProceso: '',

    fechaActualizacion:
      new Date(),

    descripcionGeneral: '',

    herramientas: [],

    procedimiento: [{
      texto: '',
      imagenes: []
    }],

    plantillas: [],

    casosEspeciales: [
      {
        titulo: '',
        texto: ''
      }
    ],

    informacionImportante: [
      {
        titulo: '',
        texto: ''
      }
    ],

    excepciones: [
      {
        titulo: '',
        texto: ''
      }
    ]
  };

  public loading = false;

  constructor(

    private processService:
      ClientProcessService,

    private dialogRef:
      MatDialogRef<AddProcessComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: any

  ) { }

  ngOnInit(): void {

    if (this.data?.process) {

      this.process =
        JSON.parse(
          JSON.stringify(
            this.data.process
          )
        );

        if (
          this.process.procedimiento &&
          this.process.procedimiento.length &&
          typeof this.process.procedimiento[0] === 'string'
        ) {

          this.process.procedimiento =
            this.process.procedimiento.map(p => ({

              texto: p,
              imagenes: []

            }));
          }
    }
  }

  trackByIndex(
    index: number,
    item: any
  ): number {

    return index;
  }

  async save() {

    try {

      this.loading = true;

      if (this.process._id) {

        await this.processService
          .updateProcess(
            this.process._id,
            this.process
          );

      } else {

        await this.processService
          .createProcess({

            clientId:
              this.data.clientId,

            ...this.process
          });
      }

      Swal.fire({
        icon: 'success',
        title: 'Información guardada',
        timer: 1500,
        showConfirmButton: false
      });

      this.dialogRef.close(true);

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: 'error',
        title: 'Error al guardar'
      });

    } finally {

      this.loading = false;
    }
  }

  close() {

    this.dialogRef.close(false);
  }

  addStep() {

  this.process.procedimiento.push({

    texto: '',
    imagenes: []

  });

}

  removeStep(
    index: number
  ) {

    this.process.procedimiento.splice(
      index,
      1
    );
  }

  addCasoEspecial() {

    this.process.casosEspeciales.push({

      titulo: '',
      texto: ''
    });
  }

  removeCasoEspecial(
    index: number
  ) {

    this.process.casosEspeciales.splice(
      index,
      1
    );
  }

  addInformacionImportante() {

    this.process.informacionImportante.push({

      titulo: '',
      texto: ''
    });
  }

  removeInformacionImportante(
    index: number
  ) {

    this.process.informacionImportante.splice(
      index,
      1
    );
  }

  addExcepcion() {

    this.process.excepciones.push({

      titulo: '',
      texto: ''
    });
  }

  removeExcepcion(
    index: number
  ) {

    this.process.excepciones.splice(
      index,
      1
    );
  }

  addHerramienta() {

    this.process.herramientas.push({

      tipo: '',
      link: '',
      usuario: '',
      password: ''
    });
  }

  removeHerramienta(
    index: number
  ) {

    this.process.herramientas.splice(
      index,
      1
    );
  }

  addPlantilla() {

    this.process.plantillas.push({

      tipo: '',
      para: '',
      mensaje: ''
    });
  }

  removePlantilla(
    index: number
  ) {

    this.process.plantillas.splice(
      index,
      1
    );
  }

}